module.exports = __webpack_public_path__ + "img/new14.e4c1e354.jpg";